<template>
  <section class="climate-page">
    <div class="container py-5">
      <h1 class="mb-3">Climate</h1>
      <p class="mb-0 text-muted">
        This is the Climate page. Add your content here.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ClimatePage'
}
</script>

<style scoped>
.climate-page {
  width: 100%;
}
</style>
